import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import axios from '@vtblife/axios';
export var QuizService = /*#__PURE__*/function () {
  function QuizService() {
    var baseURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/api/cms-service-api';
    _classCallCheck(this, QuizService);
    this.client = axios.create({
      baseURL: baseURL
    });
  }
  _createClass(QuizService, [{
    key: "createOrUpdateQuizStep",
    value: function () {
      var _createOrUpdateQuizStep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var _yield$this$client$po, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.client.post('/api/v1/quiz/passing', payload);
            case 2:
              _yield$this$client$po = _context.sent;
              data = _yield$this$client$po.data;
              return _context.abrupt("return", data);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createOrUpdateQuizStep(_x) {
        return _createOrUpdateQuizStep.apply(this, arguments);
      }
      return createOrUpdateQuizStep;
    }()
  }, {
    key: "getStatus",
    value: function () {
      var _getStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params, _ref) {
        var useCache, cacheKey, quizStatus, _yield$this$client$ge, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              useCache = _ref.useCache;
              cacheKey = "quizStatus_".concat(params.id);
              if (!useCache) {
                _context2.next = 6;
                break;
              }
              quizStatus = localStorage.getItem(cacheKey);
              if (!(quizStatus && quizStatus !== 'not seen')) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", quizStatus);
            case 6:
              _context2.next = 8;
              return this.client.get('/api/v1/quiz/status', {
                params: params
              });
            case 8:
              _yield$this$client$ge = _context2.sent;
              data = _yield$this$client$ge.data;
              if (useCache) {
                localStorage.setItem(cacheKey, data.status);
              }
              return _context2.abrupt("return", data.status);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getStatus(_x2, _x3) {
        return _getStatus.apply(this, arguments);
      }
      return getStatus;
    }()
  }, {
    key: "touchQuiz",
    value: function () {
      var _touchQuiz = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
        var _yield$this$client$po2, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.client.post('/api/v1/quiz/touch', payload);
            case 2:
              _yield$this$client$po2 = _context3.sent;
              data = _yield$this$client$po2.data;
              return _context3.abrupt("return", data);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function touchQuiz(_x4) {
        return _touchQuiz.apply(this, arguments);
      }
      return touchQuiz;
    }()
  }, {
    key: "closeQuizStep",
    value: function () {
      var _closeQuizStep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
        var _yield$this$client$po3, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.client.post('/api/v1/quiz/close', payload);
            case 2:
              _yield$this$client$po3 = _context4.sent;
              data = _yield$this$client$po3.data;
              return _context4.abrupt("return", data);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function closeQuizStep(_x5) {
        return _closeQuizStep.apply(this, arguments);
      }
      return closeQuizStep;
    }()
  }]);
  return QuizService;
}();
export var quizService = new QuizService();